import { render, staticRenderFns } from "./FairLayout.vue?vue&type=template&id=3d3e9736"
import script from "./FairLayout.vue?vue&type=script&lang=js"
export * from "./FairLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports